import script from "./ttsSel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ttsSel.vue?vue&type=script&setup=true&lang=ts"

import "./ttsSel.vue?vue&type=style&index=0&id=652bbd0e&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652bbd0e"]])

export default __exports__